document.addEventListener('turbolinks:load', function () {
  $('.popup_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.popup_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.popup_slidedown_btn').fadeIn(0));
  });

  $('.popup_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.popup_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.popup_slideup_btn').fadeIn(0));
  });
  // ------------------------------------------------------------------------------------------------
  // ポップアップ分析
  // ------------------------------------------------------------------------------------------------
  function popup_update_url() {
    const popup_id = $('#popup_select_box option:selected').val();
    const gf = $('#popup_graph_pattern_select_input').val();
    const ab = $('#popup_ab_test_select_box option:selected').val();
    const device = $('.popup_device_select').data("device");
    const start_day = $('#popup_report_start_day').val();
    const end_day = $('#popup_report_end_day').val();

    let url = new URL(window.location.href);
    let params = url.searchParams;

    if (popup_id !== 'none' && popup_id !== null && popup_id !== undefined) {
      params.set('popup_id', popup_id);
    } else {
      params.delete('popup_id');
    }

    if (ab !== 'none' && ab !== null && ab !== undefined) {
      params.set('ab', ab);
    } else {
      params.delete('ab');
    }

    if (gf) {
      params.set('gf', gf);
    } else {
      params.delete('gf');
    }

    if (device == "0" || device == "1") {
      params.set('device', device);
    } else {
      params.delete('device');
    }

    if (gf === '12') {
      params.delete('start_day');
      params.delete('end_day');
    } else {  // このelseブロックを追加
      if (start_day) {
        params.set('start_day', start_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }

      if (end_day) {
        params.set('end_day', end_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }
    }

    url.search = params.toString();
    location.href = url.toString();
  }

  // #################################################################
  // ポップアップの選択
  // #################################################################
  $('#popup_select_box').on('change', function () {
    popup_update_url();
  });

  // #################################################################
  // ABテストの選択
  // #################################################################
  $('#popup_ab_test_select_box').on('change', function () {
    popup_update_url();
  });

  // #################################################################
  // 日毎、月毎のグラフ切り替え
  // #################################################################
  $('.popup_graph_pattern_select_day, .popup_graph_pattern_select_month').on('click', function () {
    const gf_value = $(this).data('gf');
    $('#popup_graph_pattern_select_input').val(gf_value);
    popup_update_url();
  });

  // #################################################################
  // デバイスごとのグラフ切り替え
  // #################################################################
  $('.popup_device_select_all, .popup_device_select_pc, .popup_device_select_phone').on('click', function () {
    const device = $(this).data('device');
    $('.popup_device_select').data("device", device);
    popup_update_url();
  });

  // #################################################################
  // 範囲選択によるグラフ切り替え
  // #################################################################
  $('#popup_report_start_day, #popup_report_end_day').on('change', function () {
    popup_update_url();
  });

  // #################################################################
  // 表の年月切り替え
  // #################################################################
  $('#ua_popup_month_selects').on('change', function () {
    let popup_id = $('#popup_select_box option:selected').val();
    let month = $('#ua_popup_month_selects option:selected').val();
    let url = new URL(window.location.href);

    if (month != '') {
      if (url.searchParams.has('m')) {
        // 値が "0"か"1" なら "2" に更新する
        let new_value = month;
        // パラメーターの値を更新する
        url.searchParams.set('m', new_value);
      } else {
        // パラメーターにdeviceがない場合
        // 新しいパラメーターを追加する
        url.searchParams.append('m', month);
      }

      // 更新されたURLにリダイレクトする
      location.href = url.toString();
    } else {
      // monthが空文字の時は指定したURLにリダイレクトする
      // location.href = 'ugc_analysis';
    }
  });

  // #################################################################
  // ポップアップのログデータのみの削除
  // #################################################################
  $('.delete_popup_log_data').on('click', function () {
    if (!confirm('本当に削除を実行しますか？')) {
      return;
    }
    const popup_id = $('#popup_select_box option:selected').val();

    $.ajax({
      url: '/popup_report/delete_popup_log',
      type: 'POST',
      data: {
        popup_id: popup_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップのログデータと関連するデータ全ての削除
  // #################################################################
  $('.delete_popup_log_data_and_related_data').on('click', function () {
    if (!confirm('本当に完全削除を実行しますか？')) {
      return;
    }
    const popup_id = $('#popup_select_box option:selected').val();

    $.ajax({
      url: '/popup_report/delete_popup_log_and_related_data',
      type: 'POST',
      data: {
        popup_id: popup_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.href = '/popup_report/index';
      }
    });
  });

  // #################################################################
  // ポップアップのレポートのcsv出力
  // #################################################################
  $('#download_popup_csv').on('click', function () {
    const popup_id = $('#popup_select_box option:selected').val();
    const month = $('#ua_popup_month_selects option:selected').val();
    const device = $('.popup_device_select').data('device');

    let href = '/download_popup_csv';

    href += `?popup_id=${popup_id}`;
    href += `&m=${month}`;
    href += `&device=${device}`;
    location.href = href;
  });

  // ------------------------------------------------------------------------------------------------
  // ポップアップ管理
  // ------------------------------------------------------------------------------------------------
  // #################################################################
  // ポップアップ管理の新規作成
  // #################################################################
  $('#popup_create').on('click', function () {
    const name = $('.popup_input').val();

    if (!name) {
      alert('ポップアップ名を入力して下さい。');
      return;
    }

    $.ajax({
      url: '/create_popup',
      type: 'POST',
      data: {
        name: name,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('新規登録されました。');
        location.href = `/popup/index?popup_id=${data.popup_id}&popup_setting_id=${data.popup_setting_id}&popup_ab_test_id=${data.popup_ab_test_id}&device=${data.is_device}`;
      }
    });
  });

  // #################################################################
  // ポップアップ名の編集
  // #################################################################
  $('#popup_name_edit_btn').on('click', function () {
    let popup_id = $('.popup_selects option:selected').val();
    let name = $('.popup_name_val').val();

    if (!name) {
      alert('名称を記入して下さい。');
      return;
    }

    $.ajax({
      url: '/save_popup_name',
      type: 'POST',
      data: {
        popup_id: popup_id,
        name: name
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップ管理の切り替え
  // #################################################################
  $('.popup_selects').on('change', function () {
    let popup_id = $('.popup_selects option:selected').val();
    if (popup_id == 'new') {
      $('.popup_set_wrapper_display').css('display', 'block');
      $('.popup_device_setting_wrapper').css('display', 'none');
      $('.popup_ab_test_setting_wrapper').css('display', 'none');
      $('.popup_show_valid_setting_wrapper').css('display', 'none');
      $('.popup_url_setting_wrapper').css('display', 'none');
      $('.popup_excluded_url_setting_wrapper').css('display', 'none');
      $('.popup_preview_setting_wrapper').css('display', 'none');
      $('.popup_preview_url_list_wrapper').css('display', 'none');
      $('.popup_preview_position_setting_wrapper').css('display', 'none');
      $('.popup_contents_setting_wrapper').css('display', 'none');
      $('.popup_name_setting_wrapper').css('display', 'none');
      $('.contents_display_time_ms_setting_wrapper').css('display', 'none');
      $('.contents_scroll_percent_setting_wrapper').css('display', 'none');
      $('.popup_display_condition_setting_wrapper').css('display', 'none');
      $('.popup_report_jump_btn').css('display', 'none');
      $('.popup_delete_setting_wrapper').css('display', 'none');
      $('.popup_personalize_setting_wrapper').css('display', 'none');
      $('.popup_priority_setting_wrapper').css('display', 'none');
    } else {
      location.href = `/popup/index?popup_id=${popup_id}`;
    }
  });

  // #################################################################
  // ポップアップのデバイスの切り替え
  // #################################################################
  $('.popup_device_selects').on('change', function () {
    let popup_id = $('.popup_selects option:selected').val();
    // let popup_setting_id = $('.popup_device_selects:checked').data("popup_setting_id");
    let popup_setting_id = $('.popup_device_selects:checked').data("popup_setting_id");

    location.href = `/popup/index?popup_id=${popup_id}&popup_setting_id=${popup_setting_id}`;
  });

  // #################################################################
  // ポップアップの表示URL設定
  // #################################################################
  $('#popup_url_add_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="popup_url_input w-390px h-30px py-0 px-3 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="popup_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.popup_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.popup_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#popup_url_set').on('click', function () {
    let popup_id = $('.popup_selects option:selected').val();
    let urls = [];
    $('.popup_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/set_popup_url',
      type: 'POST',
      data: {
        popup_id: popup_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // ポップアップの除外URL設定
  // #################################################################
  $('#popup_excluded_url_add_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="popup_excluded_url_input w-390px h-30px py-0 px-3 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="popup_excluded_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.popup_excluded_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.popup_excluded_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#popup_excluded_url_set').on('click', function () {
    let popup_id = $('.popup_selects option:selected').val();
    let urls = [];
    $('.popup_excluded_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/set_popup_excluded_url',
      type: 'POST',
      data: {
        popup_id: popup_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // ポップアップとコンテンツの連携
  // #################################################################
  $('.popup_contents_select_box').on('change', function () {
    let popup_id = $('.popup_selects option:selected').val();
    let popup_ab_test_id = $('.popup_ab_test_selects option:selected').val();
    let content_id = $(this).val();
    $.ajax({
      url: '/save_popup_content_id',
      type: 'POST',
      data: {
        popup_id: popup_id,
        popup_ab_test_id: popup_ab_test_id,
        content_id: content_id
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // ポップアップとパーソナライズの連携
  // #################################################################
  $('.popup_personalize_select_box').on('change', function () {
    let popup_id = $('.popup_selects option:selected').val();
    let popup_ab_test_id = $('.popup_ab_test_selects option:selected').val();
    let personalize_id = $(this).val();
    $.ajax({
      url: '/save_popup_personalize_id',
      type: 'POST',
      data: {
        popup_id: popup_id,
        popup_ab_test_id: popup_ab_test_id,
        personalize_id: personalize_id
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // ポップアップのプレビュー作成
  // #################################################################
  $('#popup_create_preview_btn')
    .off()
    .on('click', function () {
      $('.loadding').css('display', 'block');
      let popup_id = $('.popup_selects option:selected').val();
      let is_device = $('.popup_device_selects:checked').val();
      let popup_setting_id = $('.popup_device_selects:checked').data("popup_setting_id");
      let popup_ab_test_id = $('.popup_ab_test_selects option:selected').val();
      let preview_url = $('#popup_create_preview_url').val();
      
      if (popup_id == '' || popup_id == null || preview_url == '') {
        $('.loadding').css('display', 'none');
        alert('必須項目を入力してください。');
        return;
      }

      $.ajax({
        url: '/popup/save_popup_preview',
        type: 'POST',
        data: {
          popup_id: popup_id,
          is_device: is_device,
          popup_setting_id: popup_setting_id,
          popup_ab_test_id: popup_ab_test_id,
          url: preview_url
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '0') {
          location.reload();
        }
      });
    });

  // #################################################################
  // ポップアップのプレビュー編集
  // #################################################################
  $('.create_popup_preview_html_edit').on('click', function () {
    let preview_id = $(this).data('id');
    let preview_url = $(this).data('url');
    $.ajax({
      url: '/edit_popup_preview_html',
      type: 'POST',
      data: {
        id: preview_id,
        url: preview_url,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        // モーダルを作成し、HTMLコンテンツとボタンを表示
        let modalHtml = `<div id="html_modal_wrapper"></div>
                        <div id="html_modal_container" class="fixed p-5 top-[2.5%] left-1/2 transform -translate-x-1/2 w-90per h-90per overflow-auto text-center bg-white dark:text-gray-500 dark:bg-gray-900 dark:border-b dark:border-black">
                          <div class="border border-gray-200 h-90per mb-4">
                            <textarea id="html_modal_text_area" class="p-2 h-full w-full"></textarea>
                          </div>
                          <div class="flex justify-center">
                            <div id="html_remove_btn" class="btn text-14px w-250px p-3 cursor-pointer text-center text-white rounded-md bg-gray-500 hover:bg-gray-700 dark:hover:bg-gray-600 dark:bg-gray-800 dark:text-gray-500">閉じる</div>
                            <div id="html_save_btn" class="btn text-14px w-250px p-3 cursor-pointer text-center text-white rounded-md bg-base-800 hover:bg-base-800 ml-2 dark:bg-dark_base dark:hover:bg-dark_base-hover dark:text-gray-500">保存</div>
                          </div>
                        </div>`;

        // モーダルをbody要素に追加
        $('body').append(modalHtml);
        $('#html_modal_text_area').text(data.html_content);

        $('#html_save_btn').on('click', function () {
          let html = $('#html_modal_text_area').val();
          $.ajax({
            url: '/update_popup_preview_html',
            type: 'POST',
            data: {
              id: preview_id,
              url: preview_url,
              html: html,
            },
            dataType: 'json',
          }).done(function (data) {
            if (data.ret == '0') {
              location.reload();
            }
          });
        });

        $('#html_modal_wrapper, #html_remove_btn').on('click', function (e) {
          $('#html_modal_wrapper, #html_modal_container, #html_modal_text_area, #html_save_btn').remove();
        });
      }
    });
  });

  // #################################################################
  // ポップアップのプレビュー削除
  // #################################################################
  $('.create_popup_preview_url_delete').on('click', function () {
    let preview_id = $(this).data('id');
    let preview_url = $(this).data('url');
    $.ajax({
      url: '/delete_popup_preview',
      type: 'POST',
      data: {
        id: preview_id,
        url: preview_url,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップの公開設定
  // #################################################################
  $('.popup_show_valid_select_box').on('change', function (event) {
    let popup_id = $('.popup_selects option:selected').val();
    let popup_ab_test_id = $('.popup_ab_test_selects option:selected').val();
    // let show_valid = $('.popup_show_valid_select_box option:selected').val();
    let show_valid = $('.popup_show_valid_select_box:checked').val();

    $.ajax({
      url: '/save_popup_show_valid',
      type: 'POST',
      data: {
        popup_id: popup_id,
        popup_ab_test_id: popup_ab_test_id,
        show_valid: show_valid
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップの公開期間設定
  // #################################################################
  $('.popup_start_datetime, .popup_end_datetime').on('change', function (event) {
    let popup_id = $('.popup_selects option:selected').val();
    let popup_ab_test_id = $('.popup_ab_test_selects option:selected').val();
    let publication_start = $('.popup_start_datetime').val();
    let publication_end = $('.popup_end_datetime').val();

    // 開始日時があり、終了日時がない場合
    if (publication_start && !publication_end) {
      let startDate = new Date(publication_start);
      startDate.setMonth(startDate.getMonth() + 1); // 1ヶ月後に設定

      let year = startDate.getFullYear();
      let month = ('0' + (startDate.getMonth() + 1)).slice(-2); // 月は0始まりなので1を加える
      let day = ('0' + startDate.getDate()).slice(-2);
      let hours = ('0' + startDate.getHours()).slice(-2);
      let minutes = ('0' + startDate.getMinutes()).slice(-2);

      publication_end = year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;

      $('.popup_end_datetime').val(publication_end);
    }

    // 終了日時があり、開始日時がない場合
    if (!publication_start && publication_end) {
      alert('開始日から入力して下さい。');
      $('.popup_end_datetime').val("");
    }

    $.ajax({
      url: '/save_popup_publication_date',
      type: 'POST',
      data: {
        popup_id: popup_id,
        popup_ab_test_id: popup_ab_test_id,
        publication_start: publication_start,
        publication_end: publication_end
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップのABテストの新規作成
  // #################################################################
  $('#create_popup_ab_test_btn').on('click', function () {
    $('.loadding').css('display', 'block');
    let popup_id = $('.popup_selects option:selected').val();
    let popup_setting_id = $('.popup_device_selects:checked').data("popup_setting_id");
    let popup_ab_test_id = $('.popup_ab_test_selects option:selected').val();

    $.ajax({
      url: '/create_popup_ab_test',
      type: 'POST',
      data: {
        popup_id: popup_id,
        popup_setting_id: popup_setting_id,
        popup_ab_test_id: popup_ab_test_id
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      } else {
        $('.loadding').css('display', 'none');
        return;
      }
    });
  });

  // #################################################################
  // デフォルトのABテストの設定
  // #################################################################
  $('#update_popup_default_ab_test_btn').on('click', function () {
    let popup_setting_id = $('.popup_device_selects:checked').data("popup_setting_id");
    let popup_ab_test_id = $("input[name='popup_ab_test_radio']:checked").val();

    $.ajax({
      url: '/update_popup_default_ab_test',
      type: 'POST',
      data: {
        popup_setting_id: popup_setting_id,
        popup_ab_test_id: popup_ab_test_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });
  
  // #################################################################
  // ポップアップのABテスト選択
  // #################################################################
  $('.popup_ab_test_selects').on('change', function () {
    let popup_id = $('.popup_selects option:selected').val();
    let popup_setting_id = $('.popup_device_selects:checked').data("popup_setting_id");
    let popup_ab_test_id = $('.popup_ab_test_selects option:selected').val();

    location.href = `/popup/index?popup_id=${popup_id}&popup_setting_id=${popup_setting_id}&popup_ab_test_id=${popup_ab_test_id}`;
  });

  // #################################################################
  // ABテストの選択切り替え
  // #################################################################
  $('#start_popup_ab_test_btn, #stop_popup_ab_test_btn').on('click', function () {
    let popup_id = $('.popup_selects option:selected').val();
    let popup_setting_id = $('.popup_device_selects:checked').data("popup_setting_id");

    $.ajax({
      url: '/update_popup_ab_test_mode',
      type: 'POST',
      data: {
        popup_id: popup_id,
        popup_setting_id: popup_setting_id
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップの表示条件設定
  // #################################################################
  $('.popup_display_condition_select_box').on('change', function (event) {
    let popup_id = $('.popup_selects option:selected').val();
    let popup_ab_test_id = $('.popup_ab_test_selects option:selected').val();
    let is_display_condition = $('.popup_display_condition_select_box option:selected').val();
    $.ajax({
      url: '/save_popup_display_condition',
      type: 'POST',
      data: {
        popup_id: popup_id,
        popup_ab_test_id: popup_ab_test_id,
        is_display_condition: is_display_condition
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // 表示するまでの時間の登録
  // #################################################################
  $('#contents_display_time_ms_edit_btn').on('click', function () {
    let popup_setting_id = $('.popup_device_selects:checked').data("popup_setting_id");
    let popup_ab_test_id = $("input[name='popup_ab_test_radio']:checked").val();

    let contents_id = $(this).data("content_id");
    let display_time_ms = $('.contents_display_time_ms_val').val();

    if (!display_time_ms) {
      alert('秒数を記入して下さい。');
      return;
    }

    $.ajax({
      url: '/save_display_time_ms',
      type: 'POST',
      data: {
        popup_setting_id: popup_setting_id,
        popup_ab_test_id: popup_ab_test_id,
        contents_id: contents_id,
        display_time_ms: display_time_ms
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // スクロール割合の登録
  // #################################################################
  $('#contents_scroll_percent_edit_btn').on('click', function () {
    let popup_setting_id = $('.popup_device_selects:checked').data("popup_setting_id");
    let popup_ab_test_id = $("input[name='popup_ab_test_radio']:checked").val();

    let contents_id = $(this).data("content_id");
    let scroll_percent = $('.contents_scroll_percent_val').val();

    if (!scroll_percent) {
      alert('秒数を記入して下さい。');
      return;
    }

    $.ajax({
      url: '/save_scroll_percent',
      type: 'POST',
      data: {
        popup_setting_id: popup_setting_id,
        popup_ab_test_id: popup_ab_test_id,
        contents_id: contents_id,
        scroll_percent: scroll_percent
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップ施策削除
  // #################################################################
  $('#popup_delete_btn').on('click', function () {
    let popup_id = $('.popup_selects option:selected').val();

    if (!confirm('完全に削除され復元することはできません。本当に削除しますか？')) {
      return;
    }

    $.ajax({
      url: '/popup/delete_popup',
      type: 'POST',
      data: {
        popup_id: popup_id,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('ポップアップ施策を削除しました。');
      location.href = `/popup/index`;
    });
  });

  // #################################################################
  // ポップアップ施策表示優先度設定
  // #################################################################
  $('.popup_priority_select_box').on('click', function () {
    let popup_ab_test_id = $('.popup_ab_test_selects option:selected').val();
    let priority = Math.abs($(this).val());

    if (priority === null) {
      $('.popup_priority_select_box_plus_val').val(0);
      return;
    }
    
    $.ajax({
      url: '/popup/save_popup_priority',
      type: 'POST',
      data: {
        popup_ab_test_id: popup_ab_test_id,
        priority: priority
      },
      dataType: 'json',
    }).done(function (data) {
      // $('.popup_priority_select_box').val(`-${priority}`);
      $('.popup_priority_select_box').val(priority);
    });
  });
});
